// Import the patch before using react-virtualized components
import "./react-virtualized-patch";
import "./main.css";
import appStores from "./appStoresConfig";
// @intrasync/designer (and other @intrasync/* packages) inject stores via
// @intrasync/react's OWN injectStores, which keeps a separate allowlist from the
// host's local injectStores. That library allowlist stays empty until
// @intrasync/react's setupInjectStores is called, so library-injected components
// (e.g. the designer header/body) can't resolve host-registered view stores like
// intraSyncDesignerViewStore. Populate it with the same store set as the host's.
import { setupInjectStores as setupLibraryInjectStores } from "@intrasync/react";
import serviceStores from "serviceStoresConfig";

import { pwaRegistration } from "./pwaUtils";
import { renderApp } from "./renderApp";
import { createRootStore } from "./createRootStore";

const rootStore = createRootStore();

pwaRegistration(rootStore);

setupLibraryInjectStores(appStores, serviceStores)
  .then(() => {
    // Stores setup complete (host + @intrasync/react allowlists)
    renderApp(rootStore);
  })
  .catch((error) => {
    console.error("Error setting up stores", error);
  });
